<template>
    <div class="modal fade" id="dailyBonusModal" tabindex="-1" role="dialog" aria-labelledby="dailyBonusModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
            <div class="modal-content box-shadow-main reward-modal">
                <!-- <div class="close-popup" data-bs-dismiss="modal"></div> -->
                <h3 class="popup-title mb-10">{{ $t('daily_bonus') }}</h3>
                <p class="txt-popup">{{ $t('daily_bonus_1') }}</p>
                <div class="align-items-center d-flex flex-column justify-content-center mt-20">
                    <h3 class="popup-title mb-2">{{ $t(user.dailybonus_dayname) }}</h3>
                    <AppIcon :src="$store.state.treasure_icon_url" :size="150" />
                    <h2 class="popup-title mt-3 mb-4">+{{ user.dailybonus_gemreward || 0 }}</h2>
                </div>
                <div class="ito-btn-large mt-20" @click="claim">
                    {{ $t('claim') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { claimDailyBonus } from "../../models/reward";
import { soundClick, soundGetReward, soundClaimTreasure } from '../../utils/utils';
import AppIcon from "@/components/common/AppIcon.vue";

export default {
    name: "DailyBonusModal",
    components: { AppIcon },
    props: ['user'],

    // watch: {
    //     $route() {
    //         this.$nextTick(function () {
    //             if (this.user.first_login == 1) {
    //                 $("#dailyBonusModal").modal('show');
    //             }
    //         })
    //     },
    // },

    // created() {
    //     this.$nextTick(function () {
    //         if (this.user.first_login == 1) {
    //             $("#dailyBonusModal").modal('show');
    //         }
    //     })

    // },

    methods: {
        claim() {
            const that = this;
            that.getSoundClick();
            that.$store.commit("setLoading", true);
            claimDailyBonus().then((response) => {
                that.$store.commit("setLoading", false);
                $('#dailyBonusModal').modal("hide");

                if (response.data.code != 0) {
                    this.$emit('updateFirstLogin', 1, response.data.msg)
                    return;
                }

                const gem_reward = response.data.results.gem_reward || 0;
                const new_gem = response.data.results.update_gem || 0;
                if (this.$store.state.user_info.contest_info.id != 0) {
                    this.$store.state.user_info.contest_info.total_gem = new_gem
                } else {
                    that.user.gem = new_gem;
                }
                const gem_txt = gem_reward >= 0 ? '+' + gem_reward : '-' + gem_reward;
                that.getSoundClaimTreasure();
                this.$emit('updateFirstLogin', 0, gem_txt)
            }).catch((response) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        getSoundClick() {
            soundClick();
        },

        getSoundGetReward() {
            soundGetReward();
        },
        getSoundClaimTreasure() {
            soundClaimTreasure();
        }
    }
}
</script>

<style scoped></style>